import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { NavLink } from "react-router-dom";

export const LoginTopLogoAndText = ({
  bigText,
  smallText,
  smallTextOne,
  display,
  linkTextBig,
  linkSmall,
  redirectLink,
}) => {
  return (
    <React.Fragment>
      <div className="login-screen-logo">
        <div className="logoleft">
          <Image
            className="d-none d-md-block d-lg-block d-xl-block login-logo"
            src={require("./../../../assets/images/Login/logo.png").default}
            fluid
          />
          <Image
            duration={0.6}
            className="d-md-none d-lg-none d-xl-none loginMobile-logo"
            src={
              require("./../../../assets/images/Login/logomobile.png").default
            }
            fluid
          />
        </div>
        <div className="linkright">
          <h4>
            {linkTextBig}
            <Link to={redirectLink} className="link-text ml-2">
              {linkSmall}
            </Link>
          </h4>
        </div>
      </div>
      <Col className="p-0 loginScreen-welcome">
        <div className="f24_700_HelveticaNeue mb-2">{bigText}</div>
        {/* <hr className="hr-smalltext-border" /> */}
        <p>{smallText}</p>
        {display === true ? <p className="new-para">{smallTextOne}</p> : ""}
      </Col>
    </React.Fragment>
  );
};

export const BackButtonIcon = ({ linkPath }) => {
  return (
    <React.Fragment>
      <Col className="back-button-css">
        <Link to={linkPath} className={"back-arrow-button-top"}>
          <i
            className="fa fa-angle-left back-arrow-button-top"
            aria-hidden="true"
          ></i>
        </Link>
      </Col>
    </React.Fragment>
  );
};

export const BackLogoIconButton = ({
  displayLogo,
  workWithLinkORClick,
  displayArrow,
  displayBackText,
  displayHelpImage,
  displayHamburgure,
  notDisplaProgressBar,
  displaySkip,
  backButtonClicked,
  hamburgurClicked,
  skipClicked,
}) => {
  const completedPage = useSelector((state) => {
    return state.onboarding.restaurantDetails.page_completed_till;
  });
  const newValue = completedPage === 22 ? 21 : completedPage;
  const devided = newValue / 21;
  const finalValue = devided * 100;
  const percentage = Math.round(finalValue);
  return (
    <React.Fragment>
      <div className="top-back-button-logo">
        <div className="log-Image-box w-50">
          <Image
            className="login-logo"
            src={
              require("./../../../assets/images/Login/logomobile.png").default
            }
            fluid
            className="log-image-width"
          />
          <div className="back-icon-text">
            {workWithLinkORClick ? (
              <div
                className="d-flex align-items-center"
                onClick={backButtonClicked}
              >
                {displayArrow ? (
                  <SVG
                    src={require("../../../assets/images/UserManagement/left-arrow.svg")}
                    alt="Back"
                    width="15px"
                  />
                ) : null}
                {displayBackText ? <p>Back</p> : null}{" "}
              </div>
            ) : (
              <Link
                to={backButtonClicked}
                className="d-flex align-items-center"
                style={{ textDecoration: "none" }}
              >
                {displayArrow ? (
                  <SVG
                    src={require("../../../assets/images/UserManagement/left-arrow.svg")}
                    alt="Back"
                    width="15px"
                  />
                ) : null}
                {displayBackText ? <p>Back</p> : null}{" "}
              </Link>
            )}
          </div>
        </div>
        <div className="help-hamburgur-and-skip justify-content-end w-50">
          {notDisplaProgressBar ? null : (
            <div className="text-right d-none d-lg-block d-lg-block d-xl-block">
              <div style={{ width: 55, height: "auto", marginLeft: "auto" }}>
                <CircularProgressbar
                  styles={buildStyles({
                    textColor: "black",
                    pathColor: "#F85032",
                    trailColor: "lightgray",
                  })}
                  value={percentage}
                  text={`${percentage}%`}
                />
              </div>
              <p
                className="f13-700 mt-2"
                style={{
                  fontFamily: "Helvetica Neue, sans-serif",
                  fontWeight: "bold",
                }}
              >
                Profile Completion
              </p>
            </div>
          )}

          {displayHelpImage ? (
            <NavLink to="/help">
              <div className="help-hamburgur-text">
                <i className="fa fa-question-circle-o" aria-hidden="true"></i>
              </div>
            </NavLink>
          ) : null}
          {displayHamburgure ? (
            <div className="help-hamburgur-text margin-hamburgur">
              <i
                className="fa fa-bars"
                aria-hidden="true"
                onClick={hamburgurClicked}
              ></i>
            </div>
          ) : null}
          {displaySkip ? (
            <div className="skip-text margin-hamburgur" onClick={skipClicked}>
              Skip
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};
